import $ from 'jquery'
import MeJobFinder from 'globalScripts/src/components/jobfinder'

$(document).ready(function () {
  let jobFinder = new MeJobFinder()

  jobFinder.init()
})



// WEBPACK FOOTER //
// ../htdocs/web/fileadmin/career/js/src/jobfinder.js